import remoteListsStore from '@sancare/typescript-commons/src/store/modules/remote-lists'
import { createStore, Store, StoreOptions, useStore as baseUseStore } from 'vuex'

import { RootState } from '@/store/types'

import adminStore from './admin/store'
import automationStore from './automation/store'
import homeStore from './home/store'
import loginStore from './login/store'
import maintenanceStore from './maintenance/store'
import manageApiKeyStore from './manage-api-key/store'
import savedSearchesStore from './saved-searches/store'
import settingsStore from './settings/store'
import statsStore from './stats/store'
import stayDisplayerStore from './stay-displayer/store'
import stayListStore from './stay-list/store'
import connectorConfigStore from './store/modules/connector-config'
import smrDiagnosisStore from './store/modules/diagnosis/smr'
import medicalActStore from './store/modules/medical-act'
import mcoStayStore from './store/modules/stay/mco'
import smrStayStore from './store/modules/stay/smr'
import toastStore from './store/modules/toast'

export const modules = {
  medicalAct: medicalActStore,
  connectorConfig: connectorConfigStore,
  maintenance: maintenanceStore,
  home: homeStore,
  stayDisplayer: stayDisplayerStore,
  stayList: stayListStore,
  mcoStay: mcoStayStore,
  smrStay: smrStayStore,
  settings: settingsStore,
  login: loginStore,
  admin: adminStore,
  savedSearches: savedSearchesStore,
  stats: statsStore,
  manageApiKey: manageApiKeyStore,
  automation: automationStore,
  smrDiagnosis: smrDiagnosisStore,
  toast: toastStore,
  remoteLists: remoteListsStore,
}

const store = createStore({
  modules,
  strict: process.env.NODE_ENV !== 'production',
} as StoreOptions<RootState>)

export function useStore(): Store<RootState> {
  return baseUseStore()
}

export default store
